var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCAbgBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 333,
    viewBox: "0 0 282 333",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.46 0.164429H0V11.6908L11.5263 11.6908V0.16444H23.0527V11.6908L11.5264 11.6908V23.2172H0V332.832H258.408L258.408 321.306H269.934L269.934 332.832H281.46L281.46 321.306H269.934V309.78H281.46L281.46 0.164429ZM258.408 321.306H246.881V309.78H258.408V321.306Z",
    fill: "#D2ECFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCAbgBlue);
export default __webpack_public_path__ + "static/media/CAbg-blue.1aacf39596fe1c61f6cae4269561c796.svg";
export { ForwardRef as ReactComponent };